module.exports = __webpack_public_path__ + "static/media/Glowco_Product Listings.50ee3ec3.docx";